module.exports = __webpack_public_path__ + "static/img/SMSXT.1bec2cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/SMSXT.png
// module id = B1RZ
// module chunks = 1